





















































import dayjs, { Dayjs } from 'dayjs';
import {
  ComponentInternalInstance,
  computed,
  defineComponent,
  getCurrentInstance,
  onMounted,
  onUnmounted,
  PropType,
  ref,
  Ref,
  watch,
} from '@vue/composition-api';
import i18n, { i18n_t } from '@/locales/i18n';
import { CoSyncCenterEvent } from '@/renderer/scripts/CoSync/SyncCenter/CoSyncCenterEvent';
import {
  CmdTypeFromRender,
  QueryHistoryType,
} from '@/renderer/scripts/CoSync/SyncCenter/ServiceMgr/ServiceCommand/CmdFromRenderer';
import { CmdFromSyncTask, SyncTaskUIStatus } from '@/renderer/scripts/CoSync/SyncCenter/SyncCenter';
import { SyncOperationType } from '@/workerProcessRenderer/scripts/CoSyncEngine/common/SyncOperationItem';

import myLoadFunc from '@/renderer/components/drawer/CoSyncRecord/loading';
import { SyncHistoryItem } from '@/renderer/scripts/CoSync/SyncCenter/Repo/CoSyncTaskDB';
import { syncCenterEventBus } from '@/renderer/scripts/CoSync/SyncCenter/SyncCenterEventBus';
import {
  ClickAreaInHistoryDrawer,
  CoSyncReporter,
} from '@/renderer/views/desktop/FileManagement/FileSync/composition/CoSyncReporter';
import useSyncTaskControlHandler, {
  canStop,
} from '@/renderer/views/desktop/FileManagement/FileSync/composition/SyncTaskControlHandler';

const LOAD_COUNT = 200;
const REFRESH_INTERVAL = 5000;

type UiHistoryItem = {
  historyId: number;
  action: string;
  fileName: string;
  time: Dayjs;
  timeWording: string;
  dayWording: string;
  isNewDay: boolean;
  actionDetail: string;
  isDir: boolean;
};

function buildItemFromHistroyItem(historyItem: SyncHistoryItem): UiHistoryItem {
  let action = '';
  let actionDetail = '';
  let isDir = false;
  switch (historyItem.operate) {
    case SyncOperationType.DWONLOAD:
      action = i18n_t('下载');
      actionDetail = i18n_t('至 {slot1}', { slot1: historyItem.relativePath });
      break;

    case SyncOperationType.UPLOAD:
      action = i18n_t('上传');
      actionDetail = i18n_t('至 {slot1}', { slot1: historyItem.relativePath });
      break;

    case SyncOperationType.CREATE_LOCAL_FOLDER:
    case SyncOperationType.CREATE_REMOTE_FOLDER:
      action = i18n_t('创建');
      // historyItem.operate === SyncOperationType.CREATE_LOCAL_FOLDER ? '本地创建' : '云端创建';
      actionDetail = `  ${historyItem.relativePath}`;
      isDir = true;
      break;

    case SyncOperationType.DELETE_REMOTE_FOLDER:
    case SyncOperationType.DELETE_LOCAL_FOLDER:
      isDir = true;
    case SyncOperationType.DELETE_REMOTE:
    case SyncOperationType.DELETE_LOCAL:
    case SyncOperationType.DELETE_REMOTE_IGNORED_EXIT:
    case SyncOperationType.DELETE_LOCAL_IGNORED_EXIT:
      action = i18n_t('删除');
      // [SyncOperationType.DELETE_LOCAL_FOLDER, SyncOperationType.DELETE_LOCAL].includes(historyItem.operate)
      //   ? '本地删除'
      //   : '云端删除';
      actionDetail = `  ${historyItem.relativePath}`;
      break;

    case SyncOperationType.MOVE_LOCAL_FOLDER:
    case SyncOperationType.MOVE_REMOTE_FOLDER:
      isDir = true;
    case SyncOperationType.MOVE_LOCAL:
    case SyncOperationType.MOVE_REMOTE:
      action = i18n_t('移动');
      // [SyncOperationType.MOVE_LOCAL_FOLDER, SyncOperationType.MOVE_LOCAL].includes(historyItem.operate)
      //   ? '本地移动'
      //   : '云端移动';
      actionDetail = i18n_t('至 {slot1}', { slot1: historyItem.relativePath });
      break;

    case SyncOperationType.RNAME_LOCAL_FOLDER:
    case SyncOperationType.RNAME_REMOTE_FOLDER:
      isDir = true;
    case SyncOperationType.RNAME_LOCAL:
    case SyncOperationType.RNAME_REMOTE:
      action = i18n_t('重命名');
      // historyItem.operate === SyncOperationType.RNAME_LOCAL ? '本地重命名' : '云端重命名';
      actionDetail = i18n_t('原名：{slot1}', { slot1: historyItem.originRelativePath });
      break;

    case SyncOperationType.SKIP_INVALID_FILENAME:
      action = i18n_t('已跳过');
      actionDetail = historyItem.relativePath;
      isDir = historyItem.isDir ?? false;
      break;

    case SyncOperationType.UPDATE_TREE_NODE:
    case SyncOperationType.DELETE_TREE_NODE:
    case SyncOperationType.MOVE_TREE_NODE:
      action = i18n_t('更新同步树');
      actionDetail = `  ${historyItem.relativePath}`;
      break;

    default: {
      const _exhaustiveCheck: never = historyItem.operate;
      return _exhaustiveCheck;
    }
  }

  const time = dayjs(historyItem.finishTime);
  const timeWording = time.format('HH:mm');
  const dayWording = time.format('MM-DD');

  return {
    historyId: historyItem.id ?? 0,
    action,
    fileName: historyItem.name,
    time,
    timeWording,
    dayWording,
    isNewDay: false,
    actionDetail,
    isDir,
  };
}

export default defineComponent({
  name: 'CoSyncRecordDrawer',
  components: {},
  props: {
    params: {
      type: Object as PropType<SyncTaskUIStatus>,
      required: true,
    },
  },
  setup(props, context) {
    const currComponent: ComponentInternalInstance = getCurrentInstance() as ComponentInternalInstance;
    const vm = currComponent.proxy;

    // 解构 props
    const syncTaskUIStatus = computed<SyncTaskUIStatus>(() => props.params);
    const realTimeTaskStatusInfo = ref<SyncTaskUIStatus>(syncTaskUIStatus.value);

    const drawerShow = computed(() => vm.$store.state.drawer.show);

    const { methods: taskControlMethods } = useSyncTaskControlHandler();

    const initLoading = ref(false);

    const loadMoreUI = 'load-more';
    const loadingUI = myLoadFunc;
    const loadingFinish = '';

    const asyncLoading = ref<any>(loadMoreUI);

    let refreshFrontTimer: number | undefined;

    const historyItemList: Ref<SyncHistoryItem[]> = ref([]);

    const tableColumns = [{ colKey: 'history-item' }];

    const listData: Ref<UiHistoryItem[]> = computed(() => {
      const uiItemList = historyItemList.value
        .sort((a, b) => {
          if (a.finishTime > b.finishTime) return -1;
          if (a.finishTime === b.finishTime) return 0;
          return 1;
        })
        .map(it => buildItemFromHistroyItem(it));

      const days: { index: number; wording: string }[] = [];
      uiItemList.forEach((item, index) => {
        const found = days.find(it => it.wording === item.dayWording);
        if (!found) {
          days.push({ index, wording: item.dayWording });
        }
      });

      days.forEach(it => {
        uiItemList[it.index].isNewDay = true;
      });

      return uiItemList;
    });

    const firstHistoryId = computed<number | undefined>(() => listData.value.at(0)?.historyId);
    const lastHistoryId = computed<number | undefined>(() => listData.value.at(-1)?.historyId);

    const onTaskStatusChange = async (syncTaskStatus: SyncTaskUIStatus) => {
      if (syncTaskStatus.coSyncInfo.localSyncId !== syncTaskUIStatus.value.coSyncInfo.localSyncId) return;

      realTimeTaskStatusInfo.value = syncTaskStatus;
    };

    const methods = {
      // 加载后面更多
      async loadMore() {
        CoSyncReporter.getInstance().reportHistoryDrawerClick(ClickAreaInHistoryDrawer.LoadMore);
        asyncLoading.value = loadingUI;

        const loadParam:
          | {
              loadFromWhichId: number;
              queryType: QueryHistoryType;
            }
          | undefined = lastHistoryId.value
          ? {
              loadFromWhichId: lastHistoryId.value,
              queryType: 'below',
            }
          : undefined;
        const loadedItems = await methods.loadHistory(syncTaskUIStatus.value, loadParam);
        historyItemList.value = [...historyItemList.value].concat(loadedItems);

        if (loadedItems.length < LOAD_COUNT) {
          asyncLoading.value = loadingFinish;
        } else {
          asyncLoading.value = loadMoreUI;
        }
      },
      // 更新前面
      async refreshFront() {
        const loadParam:
          | {
              loadFromWhichId: number;
              queryType: QueryHistoryType;
            }
          | undefined = firstHistoryId.value
          ? {
              loadFromWhichId: firstHistoryId.value,
              queryType: 'above',
            }
          : undefined;

        const loadedItems = await methods.loadHistory(syncTaskUIStatus.value, loadParam);
        if (loadedItems.length > 0) {
          historyItemList.value = loadedItems.concat(historyItemList.value).slice(0, 200);
        }
      },
      reset() {
        syncCenterEventBus.off(CoSyncCenterEvent.onTaskStatusChange, onTaskStatusChange);
        methods.stopRefreshFrontTimer();
        historyItemList.value = [];

        asyncLoading.value = loadMoreUI;
      },
      async setup(task: SyncTaskUIStatus) {
        CoSyncReporter.getInstance().reportHistoryDrawerShowBegin();
        initLoading.value = true;

        const loadedItems = await methods.loadHistory(task);
        historyItemList.value = loadedItems;

        if (loadedItems.length < LOAD_COUNT) {
          asyncLoading.value = loadingFinish;
        } else {
          asyncLoading.value = loadMoreUI;
        }

        onTaskStatusChange(task);
        syncCenterEventBus.on(CoSyncCenterEvent.onTaskStatusChange, onTaskStatusChange);

        initLoading.value = false;
        CoSyncReporter.getInstance().reportHistoryDrawerShowEnd(loadedItems.length);
      },

      async loadHistory(
        task: SyncTaskUIStatus,
        queryParam?: {
          loadFromWhichId: number;
          queryType: QueryHistoryType;
        },
      ): Promise<SyncHistoryItem[]> {
        const taskId = task.coSyncInfo.localSyncId;
        return await taskControlMethods.queryHistory(taskId, {
          count: LOAD_COUNT,
          queryType: queryParam?.queryType,
          historyId: queryParam?.loadFromWhichId,
        });
      },

      handleClear() {
        CoSyncReporter.getInstance().reportHistoryDrawerClick(ClickAreaInHistoryDrawer.Clear);
        taskControlMethods.applyNoneReturnCommand(syncTaskUIStatus.value.coSyncInfo.localSyncId, {
          cmdType: CmdTypeFromRender.CLEAR_HISTORY,
        });
        historyItemList.value = [];

        asyncLoading.value = loadingFinish;
      },

      startRefreshFrontTimer() {
        methods.stopRefreshFrontTimer();
        refreshFrontTimer = window.setInterval(() => methods.refreshFront(), REFRESH_INTERVAL);
      },
      stopRefreshFrontTimer() {
        if (refreshFrontTimer) {
          window.clearInterval(refreshFrontTimer);
          refreshFrontTimer = undefined;
          return;
        }
      },
    };

    const mounted = ref(false);
    onMounted(() => {
      mounted.value = true;
      methods.setup(syncTaskUIStatus.value);
    });

    // 处理切换
    watch(
      () => syncTaskUIStatus.value,
      async task => {
        if (task) {
          methods.reset();
          await methods.setup(task);
        }
      },
    );

    // 运行中&抽屉展示才定时
    watch(
      () => [drawerShow.value, realTimeTaskStatusInfo.value, mounted.value],
      data => {
        const show = data[0] as boolean;
        const taskStatusInfo = data[1] as SyncTaskUIStatus;
        const isMounted = data[2] as boolean;
        if (show && isMounted && canStop(taskStatusInfo)) {
          methods.startRefreshFrontTimer();
        } else {
          methods.stopRefreshFrontTimer();
        }
      },
    );

    onUnmounted(() => {
      mounted.value = false;
      methods.reset();
    });

    return {
      initLoading,
      asyncLoading,
      listData,
      tableColumns,

      loadMore: methods.loadMore,
      handleClear: methods.handleClear,

      tipsStyle: (trigger: HTMLElement) => ({ 'word-break': 'break-all' }),
    };
  },
});
